var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.average > 0)?_c('core-rating',{staticClass:"rating",attrs:{"band":_vm.band,"count":_vm.count,"transparent":true,"ratings":_vm.item.users.rated,"showIndividualRatings":false,"canClick":_vm.format.context === 'group',"value":_vm.average,"hideCount":_vm.format.context === 'user',"tooltip":_vm.tooltip},on:{"more":_vm.onRatingsClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }